var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIAvaliadores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2163_16156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.705 22.3672C6.66254 22.3672 1.75854 24.8192 1.75854 27.8404C1.75854 30.2924 4.97679 32.3613 9.42103 33.0618V36.5975L13.7996 32.219L9.42103 27.8404V30.8288C5.97291 30.2158 3.94783 28.7489 3.94783 27.8404C3.94783 26.6801 7.27553 24.5565 12.705 24.5565C18.1344 24.5565 21.4621 26.6801 21.4621 27.8404C21.4621 28.6395 19.8639 29.9093 17.0835 30.6098V32.8538C20.9476 32.011 23.6514 30.0844 23.6514 27.8404C23.6514 24.8192 18.7474 22.3672 12.705 22.3672Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8475 -0.0253906C7.09172 -0.0253906 2.43652 4.62981 2.43652 10.3856C2.43652 18.1938 12.8475 29.7203 12.8475 29.7203C12.8475 29.7203 23.2585 18.1938 23.2585 10.3856C23.2585 4.62981 18.6033 -0.0253906 12.8475 -0.0253906ZM12.8476 14.1039C10.7952 14.1039 9.12939 12.4381 9.12939 10.3857C9.12939 8.33324 10.7952 6.66748 12.8476 6.66748C14.9001 6.66748 16.5658 8.33324 16.5658 10.3857C16.5658 12.4381 14.9001 14.1039 12.8476 14.1039Z",
    fill: "#233863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2163_16156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAvaliadores);
export default __webpack_public_path__ + "static/media/IAvaliadores.444b0c629c21c6ad4e11ed4471271c41.svg";
export { ForwardRef as ReactComponent };